export default "__VITE_ASSET__DkdOhISW__"